var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H11C12.5188 0 13.75 1.23122 13.75 2.75V19.25C13.75 20.7688 12.5188 22 11 22H3C1.48122 22 0.25 20.7688 0.25 19.25V2.75C0.25 1.23122 1.48122 0 3 0ZM3 1.5C2.30964 1.5 1.75 2.05964 1.75 2.75V19.25C1.75 19.9404 2.30964 20.5 3 20.5H11C11.6904 20.5 12.25 19.9404 12.25 19.25V2.75C12.25 2.05964 11.6904 1.5 11 1.5H10V1.25C10 0.973858 9.77614 0.75 9.5 0.75H4.5C4.22386 0.75 4 0.973858 4 1.25V1.5H3ZM4 1.5V2.25C4 2.52614 4.22386 2.75 4.5 2.75H9.5C9.77614 2.75 10 2.52614 10 2.25V1.5H4Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSmall);
export default __webpack_public_path__ + "static/media/phone-small.4e959d0c342ccec25dc19f80c766914b.svg";
export { ForwardRef as ReactComponent };